export default __webpack_public_path__ + "static/media/WellnessCentre.5eb66432.png";